module.exports = __webpack_public_path__ + "img/上传.41aab37e.svg";